module.exports = __webpack_public_path__ + "static/media/035-computer-3.34ff2884.svg";